export default {
  loading: false,
  index_cache: [],
};
